import { useNavigate } from 'react-router-dom'
import { cn } from '../../utils/classNames'

const baseButtonClasses =
  'inline-flex h-[45px] w-fit items-center justify-center gap-2 rounded-lg border px-6 py-3.5 text-sm font-semibold transition-colors duration-300 disabled:cursor-not-allowed disabled:opacity-60'

const buttonVariants = {
  'primary-light': 'border-teal-primary bg-white text-teal-dark hover:bg-teal-dark hover:text-white',
  'primary-dark': 'border-teal-primary bg-blue-darkest text-white hover:bg-white hover:text-blue-darkest',
  'secondary-light': 'border-white bg-transparent text-white hover:bg-white hover:text-blue-darkest',
  'secondary-dark': 'border-blue-darkest bg-transparent text-blue-darkest hover:bg-blue-darkest hover:text-white',
  tertiary: 'border-white bg-transparent text-white hover:bg-white hover:text-blue-darkest',
}

const getButtonClasses = (buttonType = '') => {
  const variantKey = Object.keys(buttonVariants).find((key) => buttonType.includes(key))

  return cn(
    baseButtonClasses,
    buttonVariants[variantKey] || buttonVariants['secondary-dark'],
    buttonType.includes('btn-127w') && 'w-[130.92px]'
  )
}

function Button({
  label,
  buttonType,
  onClick,
  type = 'button',
  icon,
  disabled,
  navigateTo,
  navigateExternal,
}) {
  const navigate = useNavigate()

  const handleClick = (event) => {
    if (onClick) {
      onClick(event)
    }
    if (navigateTo) {
      navigate(navigateTo)
    }
    if (navigateExternal) {
      window.open(navigateExternal, '_blank', 'noopener,noreferrer')
    }
  }

  return (
    <button className={getButtonClasses(buttonType)} onClick={handleClick} type={type} disabled={disabled}>
      {icon}
      {label}
    </button>
  )
}

export default Button
